import React, { useRef, useState, useEffect } from 'react';

import Modal from 'react-bootstrap/Modal';
import { MensajeCapcha } from '../../mensajes';
import { Mensaje, MensajeSiNo } from '../../mensajes2';

import { Dimmer } from "../../spinner";


import { ValidCaptcha, validaSoloNumero, formatMoneda, validaMonto, formatoMonto, seleccionarCampo, validaNumeroTelefono, cmes } from '../../../util/varios';

import 'react-tabs/style/react-tabs.css';
import TablaDeudaComercio from './tablaDeudaComercios';
import TablaPagosComercio from './tablaPagosComercios';
import { TabActividadesDeclara } from './modalTabActividadesDeclaraUC';
import RetencionesxDeclaracion from './modalRetencionesxDeclaracion';

import useTableScroll from "../../useTableScroll";
import { calculoMontoPagar, sumaDatos } from '../../../util/OperacionesDeclaracion';
import moment from 'moment';
import axios from 'axios';

export const DeclararUCRet = (props) => {

    const headCells = [
        { id: 'codigo', label: 'CÓDIGO', textAlign: "center" },
        { id: 'descripcion', label: 'DESCRIPCIÓN DE LA ACTIVIDAD', textAlign: "center" },
        { id: 'alicuota', label: 'ALICUOTA', width: '10px', textAlign: "center" },
        { id: 'montodeclarado', label: 'MONTO DECLARADO', textAlign: "center" },
        { id: 'montodeclarar', label: 'MONTO A PAGAR', textAlign: "center" },
        { id: 'montopetro', label: 'MONTO A PAGAR U.C.', textAlign: "center" },
        { id: 'fecha', label: 'FECHA DECLARACIÓN', textAlign: "center" },
    ]

    /*  variables de estados */

    const btnCancela = useRef();
    const btnSalir = useRef();
    const btnProcesar = useRef();
    const btnImprimir = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar7, setMostrar7] = useState(false);
    const [habiBot, setHabibot] = useState(true);
    const [habiCance, setHabiCance] = useState(true);
    const [habiQuince, setHabiQuince] = useState(true);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(JSON.parse(localStorage.getItem('fechasistema')));
    const [permisoElimDecla, setPermisoElimDecla] = useState();
    const [permisoAcred, setPermisoAcred] = useState();
    const [desde, setDesde] = useState(0);
    const [retenxComer, setRetenxComer] = useState([]);
    const [totRetenComer, setTotRetenComer] = useState(0.00);
    const txtIdComercio = useRef();
    const txtRitm = useRef();
    const cmbMes = useRef();
    const cmbAnio = useRef();
    const cmbQuincena = useRef();
    const txtDenominacionCome = useRef();
    const txtRif = useRef();
    const txtTlfContri = useRef();
    const txtNumLicencia = useRef();
    const txtSectorCatastral = useRef();
    const txtDireccionContri = useRef();
    const txtNombreRespon = useRef();
    const txtCedula = useRef();
    const txtEstimado = useRef();
    const txtSaldoFavor = useRef();
    const txtReintegro = useRef();
    const txtRetenciones = useRef();
    const txtCreditoFiscal = useRef();
    const txtPorceDescuento = useRef();
    const txtTotalImpuesto = useRef();
    const txtRecargo = useRef();
    const txtIntereses = useRef();
    const txtMulta = useRef();
    const txtDeducible = useRef();
    const txtMontoDescuento = useRef();
    const txtMontoTotal = useRef();
    const txtMontoTotalUC = useRef();


    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });


    const txtApellidoRespon = useRef();
    const [contar, setContar] = useState(0);
    const [contar1, setContar1] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar3, setContar3] = useState(1);
    const [contar4, setContar4] = useState(1);
    const [contar5, setContar5] = useState(0);
    const [contar6, setContar6] = useState(0);
    const [contar7, setContar7] = useState(0);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [deshabilitadoP, setDeshabilitadoP] = useState(true);
    const [deshabilitadoI, setDeshabilitadoI] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [operacionPer, setOperacionPer] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [anio, setAnio] = useState([]);
    const [comerAct, setComerAct] = useState();
    const [actixCome, setActixCome] = useState();
    const [repreAct, setRepreAct] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [liquidador, setLiquidador] = useState(localStorage.getItem('liquidador'));
    const [declaWeb, setDeclaWeb] = useState();
    const [creditoCome, setCreditoCome] = useState('0,00');
    const [factorCambio, setFactorCambio] = useState(0)

    const [radioTipo, setRadioTipo] = useState('2');
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [datoUT, setDatoUT] = useState([]);
    const [datoCalculo, setDatoCalculo] = useState([]);
    const [visibleDefi, setVisibleDefi] = useState('hidden');
    const [visibleRegu, setVisibleRegu] = useState('visible');
    const [visibleCmbQ, setVisibleCmbQ] = useState('collapse');

    const [records, setRecords] = useState([]);
    const [totDeuda, setTotDeuda] = useState("0,00");
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const [url, setUrl] = useState('');

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const cerrarModal = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })

        //props.onHideCancela()
    }

    const selectDjurada = (idcomercio, anio, mes, tipo) => {
        setMostrar2(false)
        let endpoint = `${op.conexion}/api/industria/djuradacomercio?idcomercio=${idcomercio}&anio=${anio}&mes=${mes}&tipo=${tipo}`;
        console.log(endpoint)
        setActivate(true)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                setActivate(false);
                var totImpu = parseFloat('0.00');
                var totPagarUC = parseFloat('0.00');

                var monDedu = parseFloat('0.00');
                var sfavor = parseFloat('0.00');
                var totPagar = parseFloat('0.00');
                var monEst = parseFloat('0.00');
                setContar4(1);
                setRecords(response.data);
                if (response.data.length > 0) {
                    setHabibot(false);
                    setHabiCance(false);
                } else {
                    setHabibot(true);
                    setHabiCance(true);
                }

                if (response.data.length > 0) {
                    //setDeshabilitado(true);
                    //setDeshabilitadoI(true);
                    console.log(response.data)
                    for (let a = 0; a < response.data.length; a++) {
                        totImpu += parseFloat(response.data[a].montoapagar);
                    };

                    if (radioTipo === '1') {
                        txtEstimado.current.value = formatMoneda(response.data[0].montoestimado.toString().replace('.', ','), ',', '.', 2);
                        monEst = parseFloat(response.data[0].montoestimado);
                    } else {
                        txtEstimado.current.value = '0,00';
                        monEst = parseFloat(0.00);
                    }
                    monDedu = parseFloat(response.data[0].reintegro) + parseFloat(response.data[0].retenciones) + parseFloat(response.data[0].creditofavor) + parseFloat(response.data[0].montodescuento);
                    totPagar = totImpu + (radioTipo === '1' ? parseFloat(0.00) : parseFloat(response.data[0].recargo)) + parseFloat(response.data[0].interes) + (radioTipo === '1' ? parseFloat(0.00) : parseFloat(response.data[0].multa)) - monDedu - monEst;
                    totPagar = totPagar.toFixed(2);
                    totPagarUC = totPagar / response.data[0].valorpetro;
                    totPagarUC = totPagarUC.toFixed(2);
                    txtReintegro.current.value = formatMoneda(response.data[0].reintegro.toString().replace('.', ','), ',', '.', 2);
                    txtRetenciones.current.value = formatMoneda(response.data[0].retenciones.toString().replace('.', ','), ',', '.', 2);
                    txtCreditoFiscal.current.value = formatMoneda(response.data[0].creditofavor.toString().replace('.', ','), ',', '.', 2);
                    txtPorceDescuento.current.value = formatMoneda(response.data[0].porcedescuento.toString().replace('.', ','), ',', '.', 2);
                    txtTotalImpuesto.current.value = formatMoneda(totImpu.toFixed(2).toString().replace('.', ','), ',', '.', 2);
                    txtRecargo.current.value = formatMoneda(response.data[0].recargo.toString().replace('.', ','), ',', '.', 2);
                    txtIntereses.current.value = formatMoneda(response.data[0].interes.toString().replace('.', ','), ',', '.', 2);
                    txtMulta.current.value = formatMoneda(response.data[0].multa.toString().replace('.', ','), ',', '.', 2);
                    txtDeducible.current.value = formatMoneda(monDedu.toFixed(2).toString().replace('.', ','), ',', '.', 2);
                    txtMontoDescuento.current.value = formatMoneda(response.data[0].montodescuento.toString().replace('.', ','), ',', '.', 2);
                    if (totPagar < 0) {
                        txtSaldoFavor.current.value = formatMoneda((totPagar * -1).toFixed(2).toString().replace('.', ','), ',', '.', 2);
                        txtMontoTotal.current.value = '0,00';
                        txtMontoTotalUC.current.value = '0,00';

                        sfavor = (totPagar * -1).toFixed(2);
                    } else {
                        txtSaldoFavor.current.value = '0,00';
                        txtMontoTotal.current.value = formatMoneda(totPagar.toString().replace('.', ','), ',', '.', 2);
                        sfavor = parseFloat('0.00').toFixed(2);
                        txtMontoTotalUC.current.value = formatMoneda(totPagarUC.toString().replace('.', ','), ',', '.', 2);
                    }
                    seleccionarRetencionesDjurada(idcomercio, anio, cmbMes.current.value, tipo);
                } else {
                    setDeshabilitado(false);
                    setDeshabilitadoI(false);
                    seleccionarRetencionesComercio(props.comercio.idcomercio, props.comercio.rif,'status = 0')
                }
                setActivate(false)



            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const seleccionarRetencionesComercio = (idcomercio, crif, condi) => {
        setMostrar2(false)
        let endpoint = `${op.conexion}/api/industria/seleccionarretencionescomercio?idcomer=${idcomercio}&crif=${crif}&condi=${condi}`;
        console.log(endpoint)
        setActivate(true)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                var reten = [];
                var tot = parseFloat(0.00);
                for (let i = 0; i < response.data.length; i++) {
                    reten.push({
                        idretencion: response.data[i].idretencion,
                        nombreagente: response.data[i].nombreagente,
                        numfactura: response.data[i].numfactura,
                        periodo: response.data[i].periodo,
                        montoretenido: response.data[i].montoretenido
                    })
                    tot = Math.round((tot + parseFloat(response.data[i].montoretenido)) * 100) / 100;
                }
                setRetenxComer(reten);
                setTotRetenComer(tot);
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const seleccionarRetencionesDjurada = (idcomer, anio, mes, tipo) => {
       
        let campos = '*';
        let nomtab = 'retencionesxdjurada';
        let condi = 'idcomercio = ' + idcomer + ' AND aniodecla = ' + anio 
                    + ' AND nummesdecla = ' + mes + ' AND tipodecla = ' + tipo;
        let orden = 'idretencion';

        let endpoint  = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        console.log(endpoint)
        setActivate(true)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                var reten = [];
                var tot = parseFloat(0.00);
                for (let i = 0; i < response.data.length; i++) {
                    reten.push({
                        idretencion: response.data[i].idretencion,
                        nombreagente: response.data[i].nombreagente,
                        numfactura: response.data[i].numfactura,
                        periodo: response.data[i].periodo,
                        montoretenido: response.data[i].montoretenido
                    })
                    tot = Math.round((tot + parseFloat(response.data[i].montoretenido)) * 100) / 100;
                }
                setRetenxComer(reten);
                setTotRetenComer(tot);
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const selectDatCal = (idcomercio, anio, mes, tipo, fecha, fecdecla) => {

        let endpoint = `${op.conexion}/api/industria/datoscalculodecla?idcomercio=${idcomercio}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}&fecdecla=${fecdecla}`;
        console.log(endpoint)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                setDatoCalculo(response.data);
                setDeshabilitadoI(true);
                console.log(response.data)
                let data = [...records];
                var resu = [];
                let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
                resu = sumaDatos(records, cmbAnio.current.value, cmbMes.current.value, response.data, tipDec, espiritu, txtRetenciones.current.value, txtReintegro.current.value);
                //txtRetenciones.current.value = resu[0].retenciones;

                //txtReintegro.current.value = formatMoneda(dataDJ.results[0].reintegro.toString().replace('.', ','), ',', '.', 2);
                txtReintegro.current.value = resu[0].acredit;
                txtCreditoFiscal.current.value = resu[0].credito;
                if (parseInt(espiritu) === 14) {
                    if (response.data.diasdesc == 0) {
                        txtPorceDescuento.current.value = formatMoneda(response.data.unidd.toString().replace('.', ','), ',', '.', 2);
                    } else {
                        txtPorceDescuento.current.value = "0,00";
                    }
                } else {
                    txtPorceDescuento.current.value = formatMoneda(response.data.porcebenef.toString().replace('.', ','), ',', '.', 2);
                }

                txtTotalImpuesto.current.value = resu[0].impuesto;
                txtRecargo.current.value = resu[0].recargos;
                txtIntereses.current.value = resu[0].intereses;
                txtMulta.current.value = resu[0].multa;
                txtDeducible.current.value = resu[0].montodeducible;
                txtMontoDescuento.current.value = resu[0].montodescuento;
                txtSaldoFavor.current.value = resu[0].saldofavor;
                txtMontoTotal.current.value = resu[0].totalpagar;
                txtMontoTotalUC.current.value = resu[0].totalpagaruc;
                if (tipDec === '1') {
                    txtEstimado.current.value = formatMoneda(response.data.montoestimado.toString().replace('.', ','), ',', '.', 2);
                } else {
                    txtEstimado.current.value = '0,00';
                }



            }

        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
            setActivate(false);



        })

    }

    const selectUT = (idcomercio, anio, mes, tipo, fecha, espiritu, totdeuda) => {

        let endpoint = `${op.conexion}/api/industria/valorut?idcomercio=${idcomercio}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}&espiritu=${espiritu}&totdeuda=${totdeuda}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                setDatoUT(response.data);
                let data = [...actixCome];
                var resu = [];
                let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
                //resu = suma(actixCome, cmbAnio.current.value, cmbMes.current.value, dataUT.results, tipDec, espiritu);
                resu = calculoMontoPagar(actixCome, response.data, cmbAnio.current.value, tipDec, espiritu);
                for (let i = 0; i < resu.length; i++) {
                    for (let x = 0; x < resu[i].activi.length; x++) {
                        if (operacion === 1) {
                            data[x].montoapagar = "0.00";
                            data[x].montodeclarado = "0.00";
                        } else {
                            data[x].montoapagar = resu[i].activi[x].montoapagar;
                        }

                    }
                }
                setActixCome(data);
                setMostrar2(true);

            }

        }).catch(function (error) {


            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const procesarDeclaracion = (body) => {

        let endpoint = `${op.conexion}/api/industria/actualizardjuradaret`;

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                if (response.data) {
                    setActivate(false);
                    //setMostrar5(false);
                    //setIdComercio(dataDec.idcomer);
                    setDesde(1);
                    setHabiCance(false);
                    if (operacion === 1) {

                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La declaración ha sido procesada de manera satisfactoria.', icono: 'informacion' });

                    } else if (operacion === 2) {

                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La declaración ha sido Eliminada de manera satisfactoria.', icono: 'informacion' });

                    } else if (operacion === 3) {

                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El Contribuyente ' + txtIdComercio.current.value + 'ha sido Eliminada de manera satisfactoria.', icono: 'informacion' });


                    }
                    setDeshabilitadoP(true);
                    let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
                    seleccionarDjurada(tipDec);
                    SelectDeudaC(txtIdComercio.current.value);
                }
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const eliminaDeclaracion = (body) => {

        let endpoint = `${op.conexion}/api/industria/eliminardjurada`;

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                if (response.data) {
                    txtTotalImpuesto.current.value = '0,00';
                    txtMontoTotal.current.value = '0,00';
                    txtMontoTotalUC.current.value = '0,00';
                    txtSaldoFavor.current.value = '0,00';
                    txtDeducible.current.value = '0,00';
                    txtReintegro.current.value = '0,00';
                    txtCreditoFiscal.current.value = '0,00';
                    txtRetenciones.current.value = '0,00';
                    txtIntereses.current.value = '0,00';
                    txtRecargo.current.value = '0,00';
                    txtEstimado.current.value = '0,00';
                    txtMulta.current.value = '0,00';
                    setRetenxComer([]);
                    setActivate(false);
                    setDesde(1);
                    setMensaje({ mostrar: true, titulo: 'ELIMINAR Declaración', texto: "La declaración del mes de " + cmbMes.current[cmbMes.current.selectedIndex].text + " se eliminó de manera satisfactoria.", icono: 'error' });
                    let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
                    seleccionarDjurada(tipDec);
                    SelectDeudaC(txtIdComercio.current.value);
                }
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const SelectDeudaC = (idcomercio) => {

        let endpoint = `${op.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=${1}`;
        console.log(endpoint)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                var deu = [];
                var his = [];
                var totdeu = parseFloat(0.00);;
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].fechapago === null) {
                        totdeu = totdeu + parseFloat(response.data[i].mondeu) + parseFloat(response.data[i].intmoradeu) + parseFloat(response.data[i].recargodeu) + parseFloat(response.data[i].multa);
                        deu.push({
                            anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                            //monto: parseInt(espiritu) === 15 ? response.data[i].mondeu * factorCambio :response.data[i].mondeu ,
                            monto: response.data[i].mondeu,
                            intereses: response.data[i].intmoradeu,
                            recargo: response.data[i].recargodeu, multa: response.data[i].multa,
                            retenciones: response.data[i].retencion, credito: response.data[i].acreditacion,
                            totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                            idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                            estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion
                        });
                    } else {
                        his.push({
                            anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                            monto: response.data[i].mondeu, intereses: response.data[i].intmoradeu,
                            recargo: response.data[i].recargodeu, multa: response.data[i].multa,
                            descuento: response.data[i].mondescue, recibo: response.data[i].numreci,
                            fechapago: response.data[i].fechapago, status: response.data[i].estatus,
                            idfac: response.data[i].idfact, estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion
                        });
                    }
                }
                setTotDeuda(formatMoneda(totdeu.toString().replace('.', ','), ',', '.', 2));
                setDeuda(deu);
                setHistorico(his);
            }
            setActivate(false);
            //setMostrar5(true);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const blanquear = () => {

        //setContar(1);
        //setContar2(0);
        //setVisibleCmbQ('hidden');
        setOperacionPer(0);
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setMostrar1(false);
        setTitulo2('');
        setMsg2('');
        setActivate(false);
        setDeshabilitadoP(true);
        setDeshabilitadoI(false);
        setContar4(1);
        setRecords([]);
        setHabibot(true);
        setHabiCance(false);
        setTotDeuda("0,00");
        txtTotalImpuesto.current.value = '0,00';
        txtMontoTotal.current.value = '0,00';
        txtMontoTotalUC.current.value = '0,00';
        txtSaldoFavor.current.value = '0,00';
        txtDeducible.current.value = '0,00';
        txtReintegro.current.value = '0,00';
        txtCreditoFiscal.current.value = '0,00';
        txtRetenciones.current.value = '0,00';
        txtIntereses.current.value = '0,00';
        txtRecargo.current.value = '0,00';
        txtEstimado.current.value = '0,00';
    }


    const procesarSolicitud = () => {
        event.preventDefault();
        setActivate(true);
        setContar2(0);
        let body = {
            operacion: operacion,
            operacionper: operacionPer,
            declaweb: declaWeb,
            fechasis: fechaSistema,
            ingresa: 0,
            idusu: idUsuario,
            come: JSON.stringify(comerAct),
            repre: JSON.stringify(repreAct),
            actixcome: JSON.stringify(actixCome)
        }
        procesarDeclaracion(body);

    }

    const seleccionarDjurada = (tipoDec) => {

        setActivate(true);
        setContar(0);
        selectDjurada(props.comercio.idcomercio, parseInt(cmbAnio.current.value, 10), cmbMes.current[cmbMes.current.selectedIndex].text, parseInt(tipoDec, 10));

    }

    const seleccionarRetenciones = () => {

        setActivate(true);
        setContar(0);
        seleccionarRetencionesComercio(props.comercio.idcomercio, props.comercio.rif,'status = 0');

    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
        procesarSolicitud();
    };


    const handleCloseMensa = (e) => {
        e.preventDefault();
        if (desde === 1) {
            setContar(1);
            setContar5(1);
            setDesde(0);
            blanquear();
            let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
            seleccionarDjurada(tipDec);
        }
        setMostrar(false);
    }

    const handleChangeRadio = (event) => {
        event.preventDefault();
        setContar3(0);
        setRadioTipo(event.target.value);
        txtTotalImpuesto.current.value = '0,00';
        txtMontoTotal.current.value = '0,00';
        txtSaldoFavor.current.value = '0,00';
        txtDeducible.current.value = '0,00';
        txtReintegro.current.value = '0,00';
        txtCreditoFiscal.current.value = '0,00';
        txtRetenciones.current.value = '0,00';
        txtIntereses.current.value = '0,00';
        txtRecargo.current.value = '0,00';
        txtEstimado.current.value = '0,00';
        let tipDec = '2';
        if (event.target.value === '1') {
            setVisibleRegu('hidden');
            setVisibleCmbQ('hidden');
            setVisibleDefi('visible');

        } else if (event.target.value === '2') {
            setVisibleRegu('visible');
            setVisibleDefi('hidden');
            setRadioTipo('2');
            setVisibleCmbQ('hidden');
            /*if (props.config.aniodesdequincena !== null && parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena) {
                if (props.config.mesdesdequincena !== null && parseInt(cmbMes.current.value, 10) >= props.config.mesdesdequincena) {
                    setVisibleCmbQ('visible');
                    setRadioTipo('3');
                    cmbQuincena.current.value = '1';
                    tipDec = '3';
                } else {
                    //setRadioTipo('2');
                    setVisibleCmbQ('hidden');
                }
            } else {
                //setRadioTipo('2');
                setVisibleCmbQ('hidden');
            }*/

        } else if (event.target.value === '3') {
            setVisibleRegu('visible');
            setVisibleDefi('hidden');
            /*if (props.config.aniodesdequincena !== null && parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena) {
                if (props.config.mesdesdequincena !== null && parseInt(cmbMes.current.value, 10) >= props.config.mesdesdequincena) {
                    setVisibleCmbQ('visible');
                    cmbQuincena.current.value = '1';
                    tipDec = '3';
                } else {
                    setRadioTipo('2');
                    setVisibleCmbQ('hidden');
                }
            } else {
                setRadioTipo('2');
                setVisibleCmbQ('hidden');
            }*/
            setRadioTipo('3');
            setVisibleCmbQ('visible');
            cmbQuincena.current.value = '1';
            tipDec = '3';
        }
        seleccionarDjurada(tipDec);
    }



    /* metodo para cerrar el modal */

    const cancelar = (e) => {
        e.preventDefault();
        setContar(1);
        setContar5(1);
        blanquear();
        //props.onHideCancela();

    }

    const salir = (e) => {
        e.preventDefault();
        setContar(1);
        setContar5(1);
        setContar3(1);
        blanquear();
        props.onHideCancela();

    }

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        setEspiritu(obj.espiritu);
        setLiquidador(obj.liquidador);
        //setPermisoElimDecla(JSON.parse(localStorage.getItem('permisos'))[0].accdeclaraciones==='' || parseInt(JSON.parse(localStorage.getItem('permisos'))[0].accdeclaraciones)===0 ? false : true);
        setPermisoElimDecla(JSON.parse(localStorage.getItem('permisos')).accdeclaraciones);
        setPermisoAcred(JSON.parse(localStorage.getItem('permisos')).accacreditacion);
        var nanio = []
        var aini = 2008;
        var afin = parseInt(obj.anioactu, 10);
        for (let i = 1; i <= afin - aini; i++) {
            nanio.push({ anio: aini + i });

        }
        setAnio(nanio);
        if (props.operacion) {
            setOperacion(props.operacion);
        }
        //setContar2(0);
        //setContar(0);
        if (props.tabactixcomer) {
            //setRecords(props.tabactixcomer);
            setActixCome(props.tabactixcomer);
        }

        /*         if (op.reportes != null) {
        
                    setUrl(op.reportes.trim());
        
                } else {
                    setUrl('');
                } */
        if (contar3 === 0 && radioTipo && cmbAnio.current && cmbMes.current) {
            let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
            setContar3(1);
            //seleccionarDjurada(tipDec);
            //seleccionarRetenciones();
        } 
    }, [props.tabactixcomer, props.comercio, props.operacion, radioTipo]);

    useEffect(() => {
        if (contar4 === 0 && records) {
            let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
            setContar4(1);
            setContar6(0);
            txtRetenciones.current.value = formatMoneda(totRetenComer.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            selectDatCal(parseInt(props.comercio.idcomercio, 10), cmbAnio.current.value, cmbMes.current.value, tipDec, fechaSistema, records[0].fechadeclaracion);

        }
    }, [records]);

    const handleCmbMes = (event) => {

        event.preventDefault();
        txtTotalImpuesto.current.value = '0,00';
        txtMontoTotal.current.value = '0,00';
        txtMontoTotalUC.current.value = '0,00';
        txtSaldoFavor.current.value = '0,00';
        txtDeducible.current.value = '0,00';
        txtReintegro.current.value = '0,00';
        txtCreditoFiscal.current.value = '0,00';
        txtRetenciones.current.value = '0,00';
        txtIntereses.current.value = '0,00';
        txtRecargo.current.value = '0,00';
        txtEstimado.current.value = '0,00';
        txtMulta.current.value = '0,00';
        //nanio = Integer.parseInt(cmbAño.getText());
        //cmes = cmbMes.getText().trim();
        let tipDec = radioTipo;
        if (props.config.aniodesdequincena !== null && parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena) {
            if (parseInt(cmbAnio.current.value, 10) === props.config.aniodesdequincena) {
                if (props.config.mesdesdequincena !== null && event.target.value >= props.config.mesdesdequincena) {
                    setHabiQuince(true);
                    if (tipDec === '3') {
                        setVisibleCmbQ('visible');
                        cmbQuincena.current.value = '1';
                    }
                    /*if (tipDec === '2') {
                        setVisibleCmbQ('visible');
                        setRadioTipo('3');
                        tipDec = '3';
                    } else if (tipDec === '0' || tipDec === '1') {
                        setVisibleCmbQ('hidden');
                        //seleccionarDjurada(tipoDecla);
                    }*/
                } else {
                    setHabiQuince(false);
                    if (tipDec === '3') {
                        setRadioTipo('2');
                        setVisibleCmbQ('hidden');
                        tipDec = '2';
                    }
                }
            } else {
                setHabiQuince(true);
                if (tipDec === '3') {
                    setVisibleCmbQ('visible');
                    cmbQuincena.current.value = '1';
                }
            }
        } else {
            setHabiQuince(false);
            if (tipDec === '3') {
                setVisibleCmbQ('hidden');
                setRadioTipo('2');
                tipDec = '2';
            }
        }
        seleccionarDjurada(tipDec);
        //selectDjurada(props.comercio.idcomercio, cmbAnio.current.value, cmes(parseInt(event.target.value)), tipDec)

    };

    const handleCmbAnio = (event) => {
        event.preventDefault();
        txtTotalImpuesto.current.value = '0,00';
        txtMontoTotal.current.value = '0,00';
        txtMontoTotalUC.current.value = '0,00';
        txtSaldoFavor.current.value = '0,00';
        txtDeducible.current.value = '0,00';
        txtReintegro.current.value = '0,00';
        txtCreditoFiscal.current.value = '0,00';
        txtRetenciones.current.value = '0,00';
        txtIntereses.current.value = '0,00';
        txtRecargo.current.value = '0,00';
        txtEstimado.current.value = '0,00';
        txtMulta.current.value = '0,00';
        //nanio = Integer.parseInt(cmbAño.getText());
        //cmes = cmbMes.getText().trim();
        let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
        if (props.config.aniodesdequincena !== null && parseInt(event.target.value, 10) >= props.config.aniodesdequincena) {
            if (parseInt(event.target.value, 10) === props.config.aniodesdequincena) {
                if (props.config.mesdesdequincena !== null && parseInt(cmbMes.current.value, 10) >= props.config.mesdesdequincena) {
                    setHabiQuince(true);
                    if (tipDec === '3') {
                        setVisibleCmbQ('visible');
                        cmbQuincena.current.value = '1';
                    }
                    /*if (tipDec === '2') {
                        setVisibleCmbQ('visible');
                        setRadioTipo('3');
                        tipDec = '3';
                    } else if (tipDec === '0' || tipDec === '1') {
                        setVisibleCmbQ('hidden');
                    }*/

                } else {
                    setHabiQuince(false);
                    if (tipDec === '3') {
                        setRadioTipo('2');
                        setVisibleCmbQ('hidden');
                        tipDec = '2';
                    }
                }
            } else {
                setHabiQuince(true);
                if (tipDec === '3') {
                    setVisibleCmbQ('visible');
                    cmbQuincena.current.value = '1';
                }
            }
        } else {
            setHabiQuince(false);
            if (tipDec === '3') {
                setVisibleCmbQ('hidden');
                setRadioTipo('2');
                tipDec = '2';
            }
        }
        seleccionarDjurada(tipDec);
        //alert(cmbMes.current[cmbMes.current.selectedIndex].text);
    };

    const handleCmbMQuincena = (event) => {

        event.preventDefault();
        txtTotalImpuesto.current.value = '0,00';
        txtMontoTotal.current.value = '0,00';
        txtMontoTotalUC.current.value = '0,00';
        txtSaldoFavor.current.value = '0,00';
        txtDeducible.current.value = '0,00';
        txtReintegro.current.value = '0,00';
        txtCreditoFiscal.current.value = '0,00';
        txtRetenciones.current.value = '0,00';
        txtIntereses.current.value = '0,00';
        txtRecargo.current.value = '0,00';
        txtEstimado.current.value = '0,00';
        txtMulta.current.value = '0,00';
        //nanio = Integer.parseInt(cmbAño.getText());
        //cmes = cmbMes.getText().trim();
        let tipDec = '3';
        if (cmbQuincena.current.value === '2') {
            tipDec = '4';
        }
        seleccionarDjurada(tipDec);
        //selectDjurada(props.comercio.idcomercio, cmbAnio.current.value, cmes(parseInt(event.target.value)), tipDec)

    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (records.length === 0) {

            sigue = false;
            setTabIndex(0);
        }

        if (sigue) {
            var actixcomer = [];
            var cadMes = [];
            var peri = 0;
            let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? parseInt('4') : parseInt(radioTipo);

            for (let i = 0; i < records.length; i++) {
                actixcomer.push({
                    iddjurada: operacion === 1 ? 0 : records[i].iddjurada,
                    idactividad: records[i].idactividad,
                    montodeclarado: records[i].montodeclarado,
                    montoapagar: records[i].montoapagar,
                    fechadeclaracion: records[i].fechadeclaracion,
                    anio: cmbAnio.current.value,
                    mes: cmbMes.current[cmbMes.current.selectedIndex].text,
                    nummes: cmbMes.current.value,
                    tipo: tipDec,
                    liquidador: idUsuario,
                    temporal: false,
                    montopetro: Math.round(parseFloat(records[i].montoapagar) / parseFloat(props.factorCambio) * Math.pow(10, 4)) / Math.pow(10, 4),
                    valorpetro: props.factorCambio,
                    reintegro: txtReintegro.current.value.replace(/\./g, '').replace(',', '.'),
                    retenciones: txtRetenciones.current.value.replace(/\./g, '').replace(',', '.'),
                    porcedescuento: txtPorceDescuento.current.value.replace(/\./g, '').replace(',', '.'),
                    montodescuento: txtMontoDescuento.current.value.replace(/\./g, '').replace(',', '.'),
                    creditofavor: txtCreditoFiscal.current.value.replace(/\./g, '').replace(',', '.'),
                    recargo: txtRecargo.current.value.replace(/\./g, '').replace(',', '.'),
                    interes: txtIntereses.current.value.replace(/\./g, '').replace(',', '.'),
                    multa: txtMulta.current.value.replace(/\./g, '').replace(',', '.'),
                    totalanticipado: txtEstimado.current.value.replace(/\./g, '').replace(',', '.')
                })
            }
            let meses = props.config.mesesdecladefi.toString();
            for (let x = 0; x < meses.length; x++) {
                if (meses.substring(x, x + 1) === '1') {
                    cadMes.push(meses.substring(x, x + 1));
                    peri = peri + 1;
                }

            }


            setActivate(true);
            setContar2(0);
            let body = {
                idcomer: parseInt(props.comercio.idcomercio, 10),
                declaweb: declaWeb,
                fechasis: fechaSistema,
                idusu: idUsuario,
                dirip: localStorage.getItem('ip'),
                dirmac: localStorage.getItem('mac'),
                actixcome: JSON.stringify(actixcomer),
                cadmes: JSON.stringify(cadMes),
                peri: props.config.peripago,
                numpago: props.config.numpago,
                txtrif: txtRif.current.value,
                espiritu: espiritu,
                retenxdjur:JSON.stringify(retenxComer)
            };
            procesarDeclaracion(body);


        } else {
            setMensaje({ mostrar: true, titulo: 'Indormación', texto: 'Las actividades a declarar no deben estar vacias.', icono: 'informacion' });

        }

    };

    const handlerClickTab = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        setTabIndex(index);

    }

    const validarCapcha = () => {
        //alert(numeroD);
        var valido = ValidCaptcha();
        //var valido = true;
        if (valido) {
            setMostrar7(false);
            setTitulo("Corfirmar");
            if (operacion === 1) {
                setMensajesino({ mostrar: true, titulo: 'Confirmar', texto: "Esta seguro de registrar el contibuyente con estos datos?", icono: 'informacion' })


            } else if (operacion === 2) {
                setMensajesino({ mostrar: true, titulo: 'Confirmar', texto: "Esta seguro de modificar el contibuyente con estos datos?", icono: 'informacion' })

            } else if (operacion === 3) {

                setMensajesino({ mostrar: true, titulo: 'Confirmar', texto: "Esta seguro de eliminar el contibuyente?", icono: 'informacion' })

            }

        }
        //createDeclajurada();*/

    }

    const handleCancelaCapcha = () => {
        setMostrar7(false);
    }

    const handleCancelaRetenxDecla = () => {
        setMostrar1(false);
    }

    const mostrarRetenxDecla = () => {
        if (txtRetenciones.current.value !== "0,00"){
            setMostrar1(true);
        }
        
    }

    const agregarActividades = (event) => {
        console.log('si lo hace')
        event.preventDefault();
        if (props.tabactixcomer.length > 0 || props.tabactixcomer === '') {
            setActixCome(props.tabactixcomer);
            setOperacion(1);
            setContar5(0);
            let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
            selectUT(parseInt(props.comercio.idcomercio, 10), cmbAnio.current.value, cmbMes.current.value, tipDec, fechaSistema, espiritu, totDeuda);

        } else {
            setMensaje({ mostrar: true, titulo: 'Advertencia', texto: "No hay actividades asociadas para el año: " + cmbAnio.current.value, icono: 'error' });

        }

    };

    const eliminarDeclaracion = () => {
        if (records.length > 0) {
            let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? parseInt('4') : parseInt(radioTipo);


            setActivate(true);
            setContar7(0);
            let body = {
                cmes: cmbMes.current[cmbMes.current.selectedIndex].text,
                declaweb: declaWeb,
                dirip: localStorage.getItem('ip'),
                dirmac: localStorage.getItem('mac'),
                fechasis: fechaSistema,
                idcomer: parseInt(props.comercio.idcomercio, 10),
                idusu: idUsuario,
                montotot: txtMontoTotal.current.value.trim().replace(/\./g, '').replace(',', '.'),
                nanio: parseInt(cmbAnio.current.value),
                nmes: parseInt(cmbMes.current.value),
                tipodec: tipDec,
            }
            eliminaDeclaracion(body);

        } else {
            setMensaje({ mostrar: true, titulo: 'Advertencia', texto: "No hay actividades asociadas para el año: " + cmbAnio.current.value, icono: 'error' });
        }
    };

    const cerrarModalAgragarActi = () => {
        setActixCome(props.tabactixcomer);
        setMostrar2(false);

    }

    const validarAgregarActi = (actxcome) => {
        setDeshabilitadoP(false);
        setContar4(0);
        setRecords(actxcome);
        setHabibot(false);
        setHabiCance(true);
        setMostrar2(false);
    }

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }

        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }


        // Devuelve el número formateado
        /*event.target.value = event.target.value.replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");*/

        //return formatMoneda(e)
        
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            /*if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }*/
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.target.id === 'inputReintegro' || event.target.id === 'inputRetenciones') {
                var monDedu;
                var totPagar;
                var totPagarUC;
                var sFavor;
                let valut = datoUT ? datoUT.valorut : 1;
                monDedu = parseFloat(txtReintegro.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtRetenciones.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtCreditoFiscal.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtMontoDescuento.current.value.replace(/\./g, '').replace(',', '.'));
                monDedu = Math.round(monDedu * Math.pow(10, 2)) / Math.pow(10, 2);
                totPagar = parseFloat(txtTotalImpuesto.current.value.replace(/\./g, '').replace(',', '.')) + (radioTipo === '1' ? parseFloat(0.00) : parseFloat(txtRecargo.current.value.replace(/\./g, '').replace(',', '.'))) + parseFloat(txtIntereses.current.value.replace(/\./g, '').replace(',', '.')) + (radioTipo === '1' ? parseFloat(0.00) : parseFloat(txtMulta.current.value.replace(/\./g, '').replace(',', '.'))) - monDedu - parseFloat(txtEstimado.current.value.replace(/\./g, '').replace(',', '.'));
                totPagar = Math.round(totPagar * Math.pow(10, 2)) / Math.pow(10, 2);
                totPagarUC = totPagar / valut;
                totPagarUC = Math.round(totPagarUC * Math.pow(10, 2)) / Math.pow(10, 2);

                if (totPagar < 0.00) {
                    sFavor = totPagar * -1;
                    sFavor = Math.round(sFavor * Math.pow(10, 2)) / Math.pow(10, 2);
                    totPagar = parseFloat(0.00);
                    totPagarUC = parseFloat(0.00);
                } else {
                    sFavor = parseFloat(0.00);
                }
                txtDeducible.current.value = formatMoneda(monDedu.toString().replace('.', ','), ',', '.', 2);
                txtSaldoFavor.current.value = formatMoneda(sFavor.toString().replace('.', ','), ',', '.', 2);
                txtMontoTotal.current.value = formatMoneda(totPagar.toString().replace('.', ','), ',', '.', 2);
                txtMontoTotalUC.current.value = formatMoneda(totPagarUC.toString().replace('.', ','), ',', '.', 2);
                btnProcesar.current.focus();
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);

    };

    /* const handleInputMontoChange = (event) => {

        validaMonto(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    }; */

    const imprimirDeclaracion = ()/*  => (event) */ => {

        var reporte = '';
        var sql2 = '';
        var sql = '';
        var sql1 = '';
        var sql3 = '';

        //window.open(op.reportes + "reporte=" + reporte + "&rif=" + props.comercio.rif.trim() + "&cedula=" + props.comercio.reprelegal.trim(), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;

        if (tipDec === '1' /* && espiritu != 1 */) {
            sql2 = cmbAnio.current.value;
            sql = txtIdComercio.current.value;
            sql1 = cmbAnio.current.value
            reporte = '';
            sql3 = records[0].fechadeclaracion;
            if (parseInt(espiritu) === 9 || parseInt(espiritu) === 12) {
                reporte = 'ForDeclaracionDefinitivaXYAraure';
            } else if (parseInt(espiritu) === 11) {
                reporte = 'ForDeclaracionDefinitivaXYaritagua';
            } else {
                reporte = 'ForDeclaracionDefinitivaXY';
            }

            window.open(op.reportes + "reporte=" + reporte + "&ID=" + sql + "&DEFINITIVA=" + sql1 + "&FECHADECLARACION=" + sql3
                + "&AFAVOR=" + txtSaldoFavor.current.value + "&DEDUCIBLE=" + txtDeducible.current.value + "&NOMELA=" + liquidador,
                "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (tipDec === '0') {
            sql2 = cmbMes.current[cmbMes.current.selectedIndex].text;
            //String.valueOf(cmbMes.getText().trim());
            sql = txtIdComercio.current.value;
            sql1 = cmbAnio.current.value
            reporte = 'ForDeclaracionEstimada';
            window.open(op.reportes + "reporte=" + reporte + "&CONDICION=" + sql + "&AÑO=" + sql1 + "&MES=" + sql2 + "&NOMELA=" + liquidador, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (tipDec === '2' || tipDec === '3' || tipDec === '4') {
            sql2 = cmbMes.current[cmbMes.current.selectedIndex].text;
            //String.valueOf(cmbMes.getText().trim());
            sql = txtIdComercio.current.value;
            sql1 = cmbAnio.current.value
            sql3 = tipDec;
            var deducible = txtDeducible.current.value === '' ? '0,00' : txtDeducible.current.value;
            var recargo = txtRecargo.current.value === '' ? '0,00' : txtRecargo.current.value;
            var multa = txtMulta.current.value === '' ? '0,00' : txtMulta.current.value;
            var reintegro = txtReintegro.current.value === '' ? '0,00' : txtReintegro.current.value;
            reporte = 'ForDeclaracionMensual';

            window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&CONDICION=" + sql + "&AÑO=" + sql1 + "&MES=" + sql2 + "&DEDUCIBLE=" + deducible + "&RECARGO=" + recargo + "&MULTA=" + multa + "&REINTEGRO=" + reintegro + "&AFAVOR=" + txtSaldoFavor.current.value + "&NOMELA=" + liquidador + "&TIPODECLA=" + sql3, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");


       /*      window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&id=" + idcomercio + "&fecha=" + moment.utc(fechasistema).format('YYYY/MM/DD') + "&espiritu=" + espiritu, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        */ }

    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            style={{ backgroundColor: 'rgb(28, 27, 23,0.4)' }}
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                const fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
                const anio = moment.utc(fechasistema).format('YYYY');
                const mes = 1;
                let tipo = 2;

                console.log(props.comercio)
                setVisibleCmbQ('hidden');
                setFactorCambio(props.factorCambio)
                setContar4(1);
                //    setRecords(props.actividadxCome);
                setContar3(0);
                setRadioTipo('2');
                setVisibleRegu('visible');
                setVisibleDefi('hidden');
                if (anio) {
                    cmbAnio.current.value = anio;
                }

                if (props.config.aniodesdequincena !== null && parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena) {
                    if (parseInt(cmbAnio.current.value, 10) === props.config.aniodesdequincena) {
                        if (props.config.mesdesdequincena !== null && parseInt(cmbMes.current.value, 10) >= props.config.mesdesdequincena) {
                            setHabiQuince(true);
                            setVisibleCmbQ('visible');
                            setRadioTipo('3');
                            tipo = 3;
                        } else {
                            setHabiQuince(false);
                            setVisibleCmbQ('hidden');
                        }
                    } else {
                        setHabiQuince(true);
                        setVisibleCmbQ('visible');
                        setRadioTipo('3');
                        tipo = 3;
                    }
                } else {
                    setVisibleCmbQ('hidden');
                    setHabiQuince(false);
                }
                props.operacion < 3 ? txtRif.current.focus() : btnSalir.current.focus();


                setOperacion(props.operacion);
                setIdUsuario(props.idusuario);
                setDeclaWeb(Boolean(props.declaweb));

                setActixCome(props.tabactixcomer ? props.tabactixcomer : []);
                //setOperacion(0);
                setTabIndex(0);
                setContar1(0);
                //setcreditoCome(formatMoneda(props.comercio.credito.toString().replace('.', ','), ',', '.', 2));
                setCreditoCome(props.comercio.credito);
                setTotDeuda(props.totdeuda);
                setDeuda(props.tabdeuda);
                setHistorico(props.tabpago);
                selectDjurada(props.comercio.idcomercio, anio, cmes(parseInt(mes)), tipo);
                //seleccionarRetencionesComercio(props.comercio.idcomercio, props.comercio.rif,'status = 0')
            }}

        >
            <Modal.Header className='azulGradiant'>
                Registro de Declaraciones Juradas. - Actividad Economica.
                <div className="input-group input-group-sm mb-1 col-md-2 mr-0">
                    <span className="input-group-text bg-transparent fw-bold border-0 text-light">Valor Euro €:</span>
                    <span className="input-group-text bg-transparent fw-bold border-0 text-light">{formatMoneda(factorCambio.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</span>

                </div>
                <button ref={btnSalir} disabled={!deshabilitadoP} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

                <MensajeCapcha
                    show={mostrar7}
                    onHideAcepta={validarCapcha} onHideCancela={handleCancelaCapcha} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <RetencionesxDeclaracion 
                    show={mostrar1}
                    retenxComer={retenxComer}
                    totalRet={totRetenComer}
                    idcomercio={props.comercio ? props.comercio.idcomercio : 0}
                    anio={cmbAnio.current ? cmbAnio.current.value : ''} 
                    nmes={cmbMes.current ? cmbMes.current.value : ''}
                    tipo={radioTipo === '3' && cmbAnio.current && cmbQuincena.current.value === '2' ? '4' : radioTipo}
                    onHideCancelar={handleCancelaRetenxDecla}
                />
                <TabActividadesDeclara
                    show={mostrar2} titulo={titulo1} mensaje={msg1}
                    onHideCancela={cerrarModalAgragarActi}
                    onHideAcepta={validarAgregarActi}
                    operacion={operacion}
                    tabactixcomer={actixCome}
                    idcomercio={props.comercio ? props.comercio.idcomercio : ''}
                    mes={cmbMes.current ? cmbMes.current[cmbMes.current.selectedIndex].text : ''}
                    nmes={cmbMes.current ? cmbMes.current.value : ''}
                    anio={cmbAnio.current ? cmbAnio.current.value : ''}
                    tipodecla={radioTipo === '3' && cmbAnio.current && cmbQuincena.current.value === '2' ? '4' : radioTipo}
                    datoCalculo={datoUT}
                    totdeuda={totDeuda}
                    factorCambio={factorCambio}
                    renderizar={selectDjurada}
                />
                <div >


                    <ul className="nav " id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a
                                className="rounded nav-link active bg-blue-100 text-light"
                                id="datosTributarios"
                                data-bs-toggle="tab"
                                data-bs-target="#tributarios"
                                type="button"
                                role="tab"
                                aria-controls="tributarios"
                                aria-selected="true"

                            >
                                Declaraciones Juradas
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="rounded nav-link bg-blue-200 text-light"

                                id="deuda-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#deuda"
                                type="button"
                                role="tab"
                                aria-controls="deuda"
                                aria-selected="false"

                            >
                                Relación de Deuda Vencida
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="rounded nav-link bg-blue-300 text-light"

                                id="hist-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#historico"
                                type="button"
                                role="tab"
                                aria-controls="historico"
                                aria-selected="false"

                            >
                                Relación de Pagos
                            </a>
                        </li>


                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade show active"
                            id="tributarios"
                            role="tabpanel"
                            aria-labelledby="datosTributarios"
                        >
                            {/* DATOS GENERALES */}
                            <div className='py-2 tipo-letra'>
                                <div className="row mx-auto">


                                    <div className="input-group input-group-sm col-md-2  mb-1">
                                        <span className="input-group-text" id="inputGroup-sizing-sm">Código:</span>
                                        <input type="text" readOnly ref={txtIdComercio} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.idcomercio : ''} id="inputCodigo" />
                                    </div>

                                    <div className="input-group input-group-sm col-md-2  mb-1">
                                        <span className="input-group-text" id="inputGroup-sizing-sm">RITM:</span>
                                        <input type="text" readOnly ref={txtRitm} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.ritm.trim() : ''} id="inputRitm" />
                                    </div>

                                    <div className="input-group input-group-sm col-md-2  mb-1">
                                        <span className="input-group-text" id="inputGroup-sizing-sm">Año:</span>
                                        <select name="" disabled={!deshabilitadoP} ref={cmbAnio} className="form-select form-select-sm" onChange={handleCmbAnio}>
                                            {anio && anio.map(a => (
                                                <option key={a.anio} value={a.anio}>{a.anio}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="input-group input-group-sm col-md-2  mb-1">
                                        <span className="input-group-text" id="inputGroup-sizing-sm">Mes:</span>
                                        <select name="" disabled={!deshabilitadoP} ref={cmbMes} className="form-select form-select-sm" onChange={handleCmbMes}>
                                            <option key="0" value="1">ENERO</option>
                                            <option key="1" value="2">FEBRERO</option>
                                            <option key="2" value="3">MARZO</option>
                                            <option key="3" value="4">ABRIL</option>
                                            <option key="4" value="5">MAYO</option>
                                            <option key="5" value="6">JUNIO</option>
                                            <option key="6" value="7">JULIO</option>
                                            <option key="7" value="8">AGOSTO</option>
                                            <option key="8" value="9">SEPTIEMBRE</option>
                                            <option key="9" value="10">OCTUBRE</option>
                                            <option key="10" value="11">NOVIEMBRE</option>
                                            <option key="11" value="12">DICIEMBRE</option>
                                        </select>
                                    </div>

                                    <div className="col-md-4 row" >

                                        <label className='col  align-self-center tipo-letra' htmlFor="inputRitm" style={{ fontWeight: "bold" }}>Tipo Declaración:</label>


                                        {/*  <div className="form-check form-check-inline col" style={{ visibility: parseInt(espiritu) === 0 ? 'collapse' : 'visible' }}>
                                            <input style={!deshabilitadoP ? { pointerEvents: "none", opacity: "0.7" } : {}} className="form-check-input" type="radio" name="radioTipoDecla" value="1" checked={radioTipo === '1'} onChange={handleChangeRadio} />
                                            <label className="form-check-label" htmlFor="inlineRadio2">Definitiva</label>
                                        </div> */}
                                        <div className="form-check form-check-inline col">
                                            <input style={!deshabilitadoP ? { pointerEvents: "none", opacity: "0.7" } : {}} className="form-check-input ml-2" type="radio" name="radioTipoDecla" value="2" checked={radioTipo === '2'} onChange={handleChangeRadio} />
                                            <label className="form-check-label" htmlFor="inlineRadio3">{parseInt(espiritu) === 0 ? 'Regular' : 'Anticipada'}</label>
                                        </div>
                                        <div className="form-check form-check-inline col">
                                            <input disabled={!habiQuince} style={!habiQuince ? { pointerEvents: "none", opacity: "0.7" } : {}} className="form-check-input" type="radio" name="radioTipoDecla" value="3" checked={radioTipo === '3'} onChange={handleChangeRadio} />
                                            <label className="form-check-label" htmlFor="inlineRadio3">Quincenal</label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 align-self-center" style={{ visibility: visibleCmbQ }} >
                                        <select name="" disabled={!deshabilitadoP} ref={cmbQuincena} style={{ marginBottom: "5px" }} className="form-control form-control-sm" onChange={handleCmbMQuincena} >
                                            <option key="0" value="1">PRIMERA QUINCENA</option>
                                            <option key="1" value="2">SEGUNDA QUINCENA</option>
                                        </select>
                                    </div>

                                    <div className="row col-md-12 mx-auto">
                                        <fieldset className=' row col-md-12 border-azul rounded mx-auto d-flex justify-content-between'>
                                            <legend className="float-none w-auto">Datos del Contribuyente</legend>

                                            <div className="input-group input-group-sm col-md-7 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Denominación Comercial:</span>
                                                <input type="text" readOnly ref={txtDenominacionCome} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.nombre.trim() : ''} id="inputDenoComer" />
                                            </div>



                                            <div className="input-group input-group-sm col-md-2 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Rif:</span>
                                                <input type="text" readOnly ref={txtRif} maxLength={15} className="form-control form-control-sm" placeholder="123456789" id="inputRif" defaultValue={props.comercio ? props.comercio.rif.trim() : ''} />
                                            </div>

                                            <div className="input-group input-group-sm col-md-3 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Nº de Teléfono:</span>
                                                <input type="text" readOnly ref={txtTlfContri} className="form-control form-control-sm" id="inputTlfContri" placeholder="0000-0000000" defaultValue={props.comercio ? props.comercio.telefono !== null ? props.comercio.telefono.trim() : '' : ''} />
                                            </div>

                                            <div className="input-group input-group-sm col-md-3 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Nº de Licencia:</span>
                                                <input type="text" readOnly ref={txtNumLicencia} className="form-control form-control-sm" defaultValue={props.comercio ? props.comercio.numerolicencia !== null ? props.comercio.numerolicencia.trim() : '' : ''} id="inputNumLicencia" />
                                            </div>

                                            <div className="input-group input-group-sm col-md-3 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Sector Catastral:</span>
                                                <input type="text" readOnly ref={txtSectorCatastral} className="form-control form-control-sm" id="inputSectorCatastral" maxLength={8} defaultValue={props.comercio ? props.comercio.sectorcatastral !== null ? props.comercio.sectorcatastral.trim() : '' : ''} />
                                            </div>

                                            <div className="input-group input-group-sm col-md-6 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Dirección:</span>
                                                <input type="text" readOnly ref={txtDireccionContri} className="form-control form-control-sm" id="inputDireccionContri" defaultValue={props.comercio ? props.comercio.direccion !== null ? props.comercio.direccion.trim() : '' : ''} />
                                            </div>

                                            <div className="input-group input-group-sm col-md-6 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Nombre Representante:</span>
                                                <input type="text" readOnly ref={txtNombreRespon} className="form-control form-control-sm" id="inputNomResponsable" defaultValue={props.representante ? props.representante.nombres.trim() + ' ' + props.representante.apellidos.trim() : ''} />
                                            </div>

                                            <div className="input-group input-group-sm col-md-2 mb-2">
                                                <span className="input-group-text" id="inputGroup-sizing-sm">Cédula:</span>
                                                <input type="text" readOnly ref={txtCedula} className="form-control form-control-sm" id="inputCedula" defaultValue={props.representante ? props.representante.cedula : ''} />
                                            </div>

                                            <div className='col-md-4'></div>

                                        </fieldset>
                                    </div>




                                </div>


                                <div className="row col-md-12 py-3 justify-content-between" >
                                    <div className="col-md-4">
                                        <h3 style={{ margin: "0" }}>Datos de la Declaración Jurada</h3>
                                    </div>
                                    <div className="col-md-5">
                                        <h3 style={{ margin: "0", textAlign: "center", color: "green" }} >{records && records.length > 0 && records[0].pagada ? 'La Declaración está Pagada' : ''}</h3>
                                    </div>
                                    <div className="col-md-3  justify-content-end"  >
                                        <button disabled={!habiBot} /* disabled={permisoElimDecla ? permisoElimDecla.substring(0, 1) !== "1" ? true : deshabilitadoI : true} */ className="btn btn-sm btn-info" style={{ marginLeft: "70%" }} title="Incluir" onClick={agregarActividades} ><i className="fa fa-plus"> </i> </button>
                                    </div>
                                </div>

                                <TblContainer container={{ height: 150, width: '100%', overflow: 'auto' }} >

                                    <TblHead />

                                    <tbody>
                                        {records && records.map((dju, index) => (
                                            <tr style={{ padding: "0" }} key={dju.idactividad} >
                                                <td style={{ fontSize: "10px", textAlign: "center" }}>{dju.codigociu}</td>
                                                <td style={{ fontSize: "10px", textAlign: "left" }}>{dju.descripcion}</td>
                                                <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(dju.alicuota.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(dju.montodeclarado.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(dju.montoapagar.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(dju.montopetro.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>

                                                <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(dju.fechadeclaracion).format('DD/MM/YYYY')}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </TblContainer>
                                <div className='col-md-12 mx-auto row'>
                                    <div className="rounder row col-md-4 rounded">
                                        <div className="col-md-12 d-flex justify-content-center" style={{ visibility: visibleDefi }} >
                                            <h4>Estimado Año Anterior</h4>
                                        </div>

                                        <div className="input-group input-group-sm mb-3 col-md-12" style={{ visibility: visibleDefi, height: 27 }}>
                                            <span className="input-group-text" id="inputGroup-sizing-sm">Total Estimado:</span>
                                            <input type="text" ref={txtEstimado} className="form-control form-control-sm" style={{ textAlign: "right" }} id="inputTotalEstimado" defaultValue='0,00' onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                                        </div>

                                        <div className="col-md-12 d-flex justify-content-center py-2" style={{ visibility: (records && records.length > 0 && records[0].pagada) || (records && records.length === 0) || (permisoElimDecla && permisoElimDecla.substring(1, 2) !== "1") ? 'hidden' : 'visible' }}>
                                            <button disabled={!deshabilitadoP} className="btn btn-sm btn-danger rounded-pill" style={{ marginTop: "50%" }} onClick={eliminarDeclaracion} ><i className="fa fa-trash-alt"> Eliminar Declaración y Deuda</i> </button>
                                        </div>
                                    </div>

                                    <div style={{ borderTop: 'none' }} className="row col-md-4 border-table mx-auto">
                                        <div className="row col-md-12 mx-auto px-0">

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Saldo a Favor:</span>
                                                <input type="text" readOnly ref={txtSaldoFavor} className="form-control form-control-sm my-auto bg-transparent border-0" style={{ textAlign: "right" }} id="inputISLR" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" style={{ visibility: permisoAcred && (parseInt(permisoAcred, 10) === 0 || permisoAcred.trim() === '' ? 'hidden' : 'visible') }}>
                                                <span className="input-group-text bg-transparent border-0 w-50" id="inputGroup-sizing-sm">Acreditación:</span>
                                                <input type="text" disabled={deshabilitado} ref={txtReintegro} className="form-control form-control-sm my-auto bg-transparent rounded " style={{ textAlign: "right" }} id="inputReintegro" defaultValue='0,00' onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" style={{ visibility: visibleRegu }}>
                                                <span type="button" className="input-group-text bg-transparent border-0 w-50" onClick={mostrarRetenxDecla} id="inputGroup-sizing-sm">Retenciones (Ver...):</span>
                                                <input type="text" readOnly ref={txtRetenciones} className="form-control form-control-sm my-auto bg-transparent rounded " style={{ textAlign: "right" }} id="inputRetenciones" defaultValue='0,00' onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                                                
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Credito Fiscal:</span>
                                                <input type="text" readOnly ref={txtCreditoFiscal} className="form-control form-control-sm my-auto bg-transparent border-0" style={{ textAlign: "right" }} id="inputCreditoFiscal" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" style={{ visibility: visibleRegu }}>
                                                <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">%Descuento:</span>
                                                <input type="text" readOnly ref={txtPorceDescuento} className="form-control form-control-sm my-auto bg-transparent border-0" style={{ textAlign: "right" }} id="inputISLR" defaultValue='0,00' />
                                            </div>

                                        </div>
                                    </div>
                                    <div style={{ borderTop: 'none' }} className="row col-md-4 border-table">

                                        <div className="row col-md-12 mx-auto px-0">
                                            {/* <div className="col-md-12">
                                            <h4 className='text-center'>Totales</h4>
                                        </div> */}

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Total Impuesto:</span>
                                                <input type="text" readOnly ref={txtTotalImpuesto} className="border-0 bg-transparentform-control text-uppercaseform-control-sm" style={{ textAlign: "right" }} id="inputNumRegistro" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" style={{ visibility: visibleRegu }}>
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">{props.config ? formatMoneda(props.config.porrecargo.toString().replace('.', ','), ',', '.', 2) + '% Recargos:' : '% Recargos:'}</span>
                                                <input type="text" readOnly ref={txtRecargo} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputFechaInscripcion" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">{props.config ? formatMoneda(props.config.porinteres.toString().replace('.', ','), ',', '.', 2) + '% Intereses:' : '% Intereses:'}</span>
                                                <input type="text" readOnly ref={txtIntereses} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputISLR" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" style={{ visibility: visibleRegu }}>
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Multa:</span>
                                                <input type="text" readOnly ref={txtMulta} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputCapPag" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Impuesto Deducible:</span>
                                                <input type="text" readOnly ref={txtDeducible} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputDeducible" defaultValue='0,00' onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" style={{ visibility: visibleRegu }}>
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Monto Descuento:</span>
                                                <input type="text" readOnly ref={txtMontoDescuento} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputCapSub" defaultValue='0,00' />
                                            </div>

                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Monto Total a Pagar Bs:</span>
                                                <input type="text" readOnly ref={txtMontoTotal} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputCapSub" defaultValue='0,00' />
                                            </div>
                                            <div className="input-group input-group-sm mb-0 col-md-12 px-0" >
                                                <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Monto Total a Pagar uc:</span>
                                                <input type="text" readOnly ref={txtMontoTotalUC} className="form-control form-control-sm border-0 bg-transparent" style={{ textAlign: "right" }} id="inputCapSub" defaultValue='0,00' />
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div
                            className="tab-pane fade"
                            id="deuda"
                            role="tabpanel"
                            aria-labelledby="deuda-tab"
                        >
                            <TablaDeudaComercio
                                idcomercio={props.comercio ? props.comercio.idcomercio : 0}
                                tabdeuda={deuda}
                                credito={props.comercio ? props.comercio.credito : '0,00'}
                            />
                        </div>

                        <div
                            className="tab-pane fade"
                            id="historico"
                            role="tabpanel"
                            aria-labelledby="hist-tab"
                        >
                            <TablaPagosComercio
                                tabpago={historico}
                            />
                        </div>


                    </div>




                </div>

            </Modal.Body>
            <Modal.Footer>


                <button ref={btnProcesar} disabled={!habiCance} /*disabled={permisoElimDecla ? permisoElimDecla.substring(2, 3) !== "1" ? true : deshabilitadoP : true}*/ onClick={onChangeValidar} className="btn btn-sm btn-success rounded-pill"><i className="fas fa-check-circle"> Procesar Declaración</i></button>
                <button ref={btnImprimir} disabled={records && records.length > 0 && deshabilitadoP ? false : true} onClick={imprimirDeclaracion} className="btn btn-sm btn-primary rounded-pill"><i className="fas fa-print">  Imprimir</i></button>
                <button ref={btnCancela} disabled={!habiCance} onClick={cancelar} className="btn btn-sm btn-secondary rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
                <button ref={btnSalir} disabled={!deshabilitadoP} onClick={salir} className="btn btn-sm btn-danger col-md-1 rounded-pill"><i className="fa fa-window-close">  Salir</i></button>
            </Modal.Footer>
        </Modal >
    );
}